import '@firebase/firestore';
//# sourceMappingURL=index.esm.js.map
